import React from 'react'
import PropTypes from 'prop-types'
import tw, { css } from 'twin.macro'
import { navigate } from 'gatsby'
import { DialogContent, DialogOverlay } from '@reach/dialog'
import { animated, useTransition } from 'react-spring'
import useTheme from '../../hooks/theme'
import MobileMenuItem from './mobile-menu-item'

const MobileButton = tw.button`flex w-full border-b-2 border-gray-600 hover:bg-gray-300 text-lg pl-4 py-3 text-left text-gray-700 hover:text-gray-800`

/**
 * MobileMenu - Items for the MainMenu
 * @see MainMenu
 * @param {[]} props.items - menu items array
 * @param {string} props.globalLocale - current locale
 * @param {string} props.checkedLocale - checked locale
 */
export default function MobileMenu({ items, globalLocale, checkedLocale }) {
	const {
		menu: { open: menuOpen },
		closeMenu,
	} = useTheme()
	const AnimatedDialogOverlay = animated(DialogOverlay)
	const AnimatedDialogContent = animated(DialogContent)
	const transitions = useTransition(menuOpen, null, {
		from: { opacity: 0, y: -10 },
		enter: { opacity: 1, y: 0 },
		leave: { opacity: 0, y: 10 },
	})
	return (
		<>
			{transitions.map(
				({ item, key, props: styles }) =>
					item && (
						<AnimatedDialogOverlay
							key={key}
							css={{
								opacity: styles.opacity,
								position: 'absolute',
								background: 'transparent',
								top: '102px',
								height: '100%',
							}}
						>
							<AnimatedDialogContent
								role="dialog"
								aria-label="Mobile Menu"
								id="mobile-menu"
								css={{
									transform: styles.y.interpolate(
										value => `translate3d(0px, ${value}px, 0px)`
									),
									width: '100%',
									height: '100%',
									margin: 0,
									padding: '0.5rem',
								}}
							>
								{items.map((x, i) => {
									if (!x.mega && !(x.primary === false)) {
										return (
											<MobileMenuItem key={'MobileMenuItem' + i} item={x} />
										)
									}
								})}
								{globalLocale === 'en-AU' && (
									<MobileButton
										role="menuitem"
										onClick={() => {
											closeMenu()
											navigate(`${checkedLocale}/promotions/`)
										}}
									>
										Promotions
									</MobileButton>
								)}
							</AnimatedDialogContent>
						</AnimatedDialogOverlay>
					)
			)}
		</>
	)
}
MobileMenu.propTypes = {
	items: PropTypes.array,
	globalLocale: PropTypes.string,
	checkedLocale: PropTypes.string,
}
